export const process_type = [
  { value: 2, label: "Check Out" },
  { value: 21, label: "Breakage" },
  { value: 22, label: "Change Room" },
  { value: 13, label: "Extend Booking" },
];
